import React from 'react';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Rows Component
 * @param children {React.ReactNode} Rows children
 * - ------------------- WEB PROPERTIES -------------------------
 * @param className {string} additionnal CSS Classes
 */
const Rows = ({ className, ...others }) => {
    const { styled } = useTrilogyContext();
    return React.createElement("div", { className: hashClass(styled, clsx('rows', className)), ...others });
};
export default Rows;
//# sourceMappingURL=Rows.js.map